import { render, staticRenderFns } from "./store-wares-node.vue?vue&type=template&id=b191a25e&scoped=true"
import script from "./store-wares-node.vue?vue&type=script&lang=js"
export * from "./store-wares-node.vue?vue&type=script&lang=js"
import style0 from "./store-wares-node.vue?vue&type=style&index=0&id=b191a25e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b191a25e",
  null
  
)

export default component.exports